import { render, staticRenderFns } from "./detail-proyek-modal.vue?vue&type=template&id=7baac640&scoped=true&"
import script from "./detail-proyek-modal.vue?vue&type=script&lang=js&"
export * from "./detail-proyek-modal.vue?vue&type=script&lang=js&"
import style0 from "./detail-proyek-modal.vue?vue&type=style&index=0&id=7baac640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baac640",
  null
  
)

export default component.exports